/**
 * User ID Manager
 * Manages persistent user identification using localStorage
 */

const USER_ID_KEY = "strikeup_chat_user_id";

/**
 * Generates a unique user ID
 */
function generateUserId(): string {
  return `user-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}

/**
 * Gets the current user ID from localStorage, config, URL params, or generates a new one
 */
export function getUserId(): string {
  // Priority 1: Check if userId was provided in window.chatWidgetConfig
  const configUserId = (window as any).chatWidgetConfig?.userId;
  if (configUserId) {
    localStorage.setItem(USER_ID_KEY, configUserId);
    return configUserId;
  }

  // Priority 2: Check URL parameter
  const params = new URLSearchParams(window.location.search);
  const urlUserId = params.get("userId");
  if (urlUserId) {
    localStorage.setItem(USER_ID_KEY, urlUserId);
    return urlUserId;
  }

  // Priority 3: Check localStorage
  let userId = localStorage.getItem(USER_ID_KEY);

  if (!userId) {
    // Priority 4: Generate new user ID
    userId = generateUserId();
    localStorage.setItem(USER_ID_KEY, userId);
  }

  return userId;
}

/**
 * Clears the user ID from localStorage (useful for testing/debugging)
 */
export function clearUserId(): void {
  localStorage.removeItem(USER_ID_KEY);
}

/**
 * Checks if a user ID exists in localStorage
 */
export function hasUserId(): boolean {
  return localStorage.getItem(USER_ID_KEY) !== null;
}
